import { render, staticRenderFns } from "./MaterialManageRead.vue?vue&type=template&id=4bc7fd24&scoped=true&"
import script from "./MaterialManageRead.vue?vue&type=script&lang=js&"
export * from "./MaterialManageRead.vue?vue&type=script&lang=js&"
import style0 from "./MaterialManageRead.vue?vue&type=style&index=0&id=4bc7fd24&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc7fd24",
  null
  
)

export default component.exports